import DOMPurify from 'isomorphic-dompurify';
import type { Ref, ComputedRef } from 'vue';

type UseSanitizeHtmlOptions = {
  urlToLink?: boolean;
};

export function useSanitizeHtml(
  html: Ref<string> | ComputedRef<string>,
  options: UseSanitizeHtmlOptions = {},
) {
  const sanitizedHtml = computed(() => {
    const urlReplacedHtml = html.value.replace(
      /(https?:\/\/[^\s]*)/g,
      '<a href="$1" class="text-primary-default hover:underline" target="_blank" rel="noopener">$1</a>',
    );

    return DOMPurify.sanitize(
      options.urlToLink ? urlReplacedHtml : html.value,
      {
        ALLOWED_TAGS: ['a', 'br'],
        ALLOWED_ATTR: ['class', 'href', 'rel', 'target'],
      },
    );
  });

  return {
    sanitizedHtml,
  };
}
